module.exports = __webpack_public_path__ + "static/img/participate-blast2.b61f3e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/participate-blast2.jpg
// module id = SyUH
// module chunks = 1